import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { getAuth, getSelectedPlan, hasUsedProTrial, markProTrialUsed } from '../auth';

const faqCobranca = [
  {
    q: 'Como funciona a cobrança?',
    a: 'A cobrança é feita de forma recorrente pela Kiwify, no cartão cadastrado. Você recebe um e-mail de confirmação a cada renovação.'
  },
  {
    q: 'Posso cancelar a qualquer momento?',
    a: 'Sim. Cancele quando quiser pelo painel da Kiwify, sem multa. O acesso continua até o fim do período já pago.'
  },
  {
    q: 'O plano Pro tem teste grátis?',
    a: 'Sim. O plano Pro oferece 7 dias grátis sem necessidade de cartão de crédito. Ao final, o plano é cancelado automaticamente se não houver contratação.'
  },
  {
    q: 'Posso trocar de plano depois?',
    a: 'Sim. Para fazer upgrade, basta assinar o plano desejado. Para downgrade, cancele o plano atual e assine o inferior.'
  },
  {
    q: 'Como solicito nota fiscal ou reembolso?',
    a: 'Entre em contato pelo e-mail contato@pokermindbrasil.com. Reembolsos são analisados caso a caso dentro de 7 dias após a compra.'
  },
];

function Assinatura() {
  const auth = useMemo(() => getAuth(), []);
  const selectedPlan = getSelectedPlan();
  const [isAnnual, setIsAnnual] = useState(true);
  const [openFaq, setOpenFaq] = useState(null);

  const currentPlan = (selectedPlan || auth?.user?.plan || 'free').toLowerCase();
  const userName = auth?.user?.name || 'Jogador';
  const userEmail = auth?.user?.email || '--';
  const usedProTrial = hasUsedProTrial(auth?.user?.email);

  const proHref = isAnnual ? 'https://pay.kiwify.com.br/Ad3EqAb' : 'https://pay.kiwify.com.br/TsIQh1F';
  const eliteHref = isAnnual ? 'https://pay.kiwify.com.br/VyQaS2y' : 'https://pay.kiwify.com.br/bkqOAxu';
  const proPrice = isAnnual ? '39' : '49';
  const elitePrice = isAnnual ? '79' : '99';
  const proPeriod = isAnnual ? '/mês · cobrado anualmente' : '/mês · cobrado mensalmente';
  const elitePeriod = isAnnual ? '/mês · cobrado anualmente' : '/mês · cobrado mensalmente';

  const planMeta = {
    free: {
      label: 'FREE',
      border: '1px solid rgba(255,255,255,0.08)',
      badge: { color: 'var(--muted)', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)' },
      title: 'PLANO FREE',
      message: 'Você está no plano gratuito.',
      submessage: 'Faça upgrade para desbloquear análises ilimitadas e o Coach IA completo.',
    },
    pro: {
      label: 'PRO',
      border: '1.5px solid var(--yellow)',
      badge: { color: 'var(--yellow)', background: 'rgba(245,200,0,0.12)', border: '1px solid rgba(245,200,0,0.22)' },
      title: 'PLANO PRO',
      message: 'Sua assinatura está ativa. Obrigado!',
      submessage: 'Você já liberou análises ilimitadas e recursos avançados do Coach IA.',
    },
    elite: {
      label: 'ELITE',
      border: '1.5px solid var(--green)',
      badge: { color: 'var(--green)', background: 'rgba(74,222,128,0.12)', border: '1px solid rgba(74,222,128,0.22)' },
      title: 'PLANO ELITE',
      message: 'Sua assinatura está ativa. Obrigado!',
      submessage: 'Você já está com o pacote mais completo da plataforma.',
    },
  };

  const currentPlanMeta = planMeta[currentPlan] || planMeta.free;

  return (
    <div className="asn-page">
      <header className="asn-header">
        <Link to="/dashboard" className="asn-back">← Voltar ao painel</Link>
        <Link to="/dashboard" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
          <img src={require('../logo.png')} alt="PokerMind Brasil" style={{ height: '55px', objectFit: 'contain' }} />
        </Link>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0 }}>
          <div
            style={{
              width: '36px',
              height: '36px',
              borderRadius: '999px',
              border: '1px solid rgba(245,200,0,0.25)',
              background: 'rgba(245,200,0,0.12)',
              color: 'var(--yellow)',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontFamily: "'Barlow Condensed', sans-serif",
              fontWeight: 800,
            }}
          >
            {userName.charAt(0)}
          </div>
          <span style={{ color: 'var(--white)', fontSize: '0.88rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {userName}
          </span>
        </div>
      </header>

      <main className="asn-body">
        <section className="asn-card" style={{ border: currentPlanMeta.border }}>
          <div className="asn-section-eyebrow">Sua assinatura</div>
          <div className="asn-section-title">Status do plano</div>
          <div className="asn-plan-badge" style={currentPlanMeta.badge}>{currentPlanMeta.label}</div>
          <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '1.3rem', fontWeight: 700, letterSpacing: '.04em', textTransform: 'uppercase', marginBottom: '10px' }}>
            {currentPlanMeta.title}
          </div>
          <div style={{ color: 'var(--muted)', fontSize: '0.9rem', lineHeight: 1.7, marginBottom: '18px' }}>
            Status: Ativo · Válido até: -- · Renovação: --
          </div>
          <div style={{ fontSize: '0.96rem', color: 'var(--white)', marginBottom: '6px' }}>{currentPlanMeta.message}</div>
          <div style={{ color: 'var(--muted)', lineHeight: 1.7, marginBottom: '24px' }}>{currentPlanMeta.submessage}</div>
          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            {currentPlan === 'free' && (
              <a href="#planos" className="asn-btn-primary">Fazer upgrade para Pro →</a>
            )}

            {currentPlan === 'pro' && (
              <>
                <a href="#planos" className="asn-btn-outline">Fazer upgrade para Elite →</a>
                <a
                  href="https://kiwify.com.br"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="asn-btn-danger"
                >
                  Cancelar assinatura
                </a>
              </>
            )}

            {currentPlan === 'elite' && (
              <a
                href="https://kiwify.com.br"
                target="_blank"
                rel="noopener noreferrer"
                className="asn-btn-danger"
              >
                Cancelar assinatura
              </a>
            )}
          </div>
        </section>

        <section className="asn-card">
          <div className="asn-section-eyebrow">Histórico de pagamentos</div>
          <div className="asn-section-title">Pagamentos</div>
          <table className="asn-table">
            <thead>
              <tr>
                <th>Data</th>
                <th>Descrição</th>
                <th>Valor</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>--</td>
                <td>--</td>
                <td>--</td>
                <td>--</td>
              </tr>
            </tbody>
          </table>
          <div className="asn-empty">
            Nenhum pagamento registrado ainda.
            <br />
            Os pagamentos aparecem aqui após integração com a Kiwify.
          </div>
          <div style={{ color: 'var(--muted)', fontSize: '0.8rem', marginBottom: '10px' }}>
            O histórico completo está disponível no painel da Kiwify.
          </div>
          <a href="https://kiwify.com.br" target="_blank" rel="noopener noreferrer" className="asn-btn-outline">
            Acessar painel da Kiwify ↗
          </a>
        </section>

        <section id="planos">
          <div className="asn-section-eyebrow">Comparativo de planos</div>
          <div className="asn-section-title">Escolha o plano ideal</div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '14px', marginBottom: '24px', flexWrap: 'wrap' }}>
            <span style={{ fontSize: '0.88rem', fontWeight: 500, color: isAnnual ? 'var(--muted)' : 'var(--white)' }}>Mensal</span>
            <button
              type="button"
              onClick={() => setIsAnnual((prev) => !prev)}
              style={{ width: '52px', height: '28px', borderRadius: '14px', background: 'var(--yellow)', cursor: 'pointer', position: 'relative', flexShrink: 0, border: 'none' }}
            >
              <div style={{ width: '22px', height: '22px', borderRadius: '50%', background: '#000', position: 'absolute', top: '3px', left: '3px', transition: 'transform .25s', transform: isAnnual ? 'translateX(24px)' : 'translateX(0)' }} />
            </button>
            <span style={{ fontSize: '0.88rem', fontWeight: 500, color: isAnnual ? 'var(--white)' : 'var(--muted)' }}>
              Anual <span style={{ background: 'rgba(74,222,128,.15)', color: 'var(--green)', fontSize: '0.72rem', fontWeight: 700, padding: '2px 8px', borderRadius: '4px', marginLeft: '4px' }}>-20%</span>
            </span>
          </div>

          <div className="asn-planGrid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3,minmax(0,1fr))', gap: '16px' }}>
            <div className="asn-card" style={{ padding: '24px 20px', textAlign: 'center', position: 'relative', border: currentPlan === 'free' ? '1.5px solid rgba(255,255,255,0.24)' : '1px solid rgba(255,255,255,0.08)' }}>
              {currentPlan === 'free' && <div className="asn-currentPlan">Seu plano atual</div>}
              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: '0.78rem', letterSpacing: '.14em', textTransform: 'uppercase', color: 'var(--muted)', marginBottom: '8px' }}>Free</div>
              <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', gap: '2px', lineHeight: 1, marginBottom: '4px' }}>
                <span style={{ fontSize: '1rem', color: 'var(--muted)', marginTop: '5px' }}>R$</span>
                <span style={{ fontFamily: "'Barlow', sans-serif", fontWeight: 600, fontSize: '2.8rem', letterSpacing: '-.02em' }}>0</span>
              </div>
              <div style={{ fontSize: '0.72rem', color: 'var(--muted)', marginBottom: '16px' }}>para sempre</div>
              <ul style={{ listStyle: 'none', textAlign: 'left', width: '100%', display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '20px' }}>
                <li style={{ fontSize: '0.78rem', color: 'var(--muted)', display: 'flex', gap: '8px' }}><span style={{ color: 'var(--green)' }}>✓</span>Coach IA — 5 msgs/dia</li>
                <li style={{ fontSize: '0.78rem', color: 'var(--muted)', display: 'flex', gap: '8px' }}><span style={{ color: 'var(--green)' }}>✓</span>3 análises de torneio</li>
                <li style={{ fontSize: '0.78rem', color: 'var(--muted)', display: 'flex', gap: '8px' }}><span style={{ color: 'var(--green)' }}>✓</span>Dashboard básico</li>
              </ul>
              <Link to="/dashboard" className="asn-btn-outline" style={{ width: '100%' }}>Continuar grátis</Link>
            </div>

            <div className="asn-card" style={{ padding: '24px 20px', textAlign: 'center', position: 'relative', border: currentPlan === 'pro' ? '1.5px solid var(--yellow)' : '1.5px solid var(--yellow)', background: 'linear-gradient(160deg,rgba(245,200,0,.07),rgba(255,255,255,0.03) 60%)' }}>
              {currentPlan === 'pro' ? (
                <div className="asn-currentPlan" style={{ background: 'var(--yellow)', color: '#000' }}>Seu plano atual</div>
              ) : (
                <div className="asn-currentPlan" style={{ background: 'var(--yellow)', color: '#000' }}>Recomendado</div>
              )}
              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: '0.78rem', letterSpacing: '.14em', textTransform: 'uppercase', color: 'var(--yellow)', marginBottom: '8px' }}>Pro</div>
              <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', gap: '2px', lineHeight: 1, marginBottom: '4px' }}>
                <span style={{ fontSize: '1rem', color: 'var(--muted)', marginTop: '5px' }}>R$</span>
                <span style={{ fontFamily: "'Barlow', sans-serif", fontWeight: 600, fontSize: '2.8rem', letterSpacing: '-.02em' }}>{proPrice}</span>
              </div>
              <div style={{ fontSize: '0.72rem', color: 'var(--muted)', marginBottom: '16px' }}>{proPeriod}</div>
              <ul style={{ listStyle: 'none', textAlign: 'left', width: '100%', display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '20px' }}>
                {['Coach IA — 25 msgs/dia', 'Análises ilimitadas', 'Plano de estudo por IA', '7 perfis de vilão', 'Biblioteca de aulas'].map((feature) => (
                  <li key={feature} style={{ fontSize: '0.78rem', color: 'var(--white)', display: 'flex', gap: '8px' }}>
                    <span style={{ color: 'var(--yellow)' }}>✓</span>{feature}
                  </li>
                ))}
              </ul>
              <a
                href={proHref}
                target="_blank"
                rel="noopener noreferrer"
                className="asn-btn-primary"
                style={{ width: '100%' }}
                onClick={() => {
                  if (!usedProTrial) markProTrialUsed(auth?.user?.email);
                }}
              >
                {usedProTrial ? 'Assinar Pro' : 'Testar grátis por 7 dias'}
              </a>
            </div>

            <div className="asn-card" style={{ padding: '24px 20px', textAlign: 'center', position: 'relative', border: currentPlan === 'elite' ? '1.5px solid var(--green)' : '1px solid rgba(255,255,255,0.08)' }}>
              {currentPlan === 'elite' && <div className="asn-currentPlan" style={{ background: 'var(--green)', color: '#000' }}>Seu plano atual</div>}
              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: '0.78rem', letterSpacing: '.14em', textTransform: 'uppercase', color: currentPlan === 'elite' ? 'var(--green)' : 'var(--muted)', marginBottom: '8px' }}>Elite</div>
              <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', gap: '2px', lineHeight: 1, marginBottom: '4px' }}>
                <span style={{ fontSize: '1rem', color: 'var(--muted)', marginTop: '5px' }}>R$</span>
                <span style={{ fontFamily: "'Barlow', sans-serif", fontWeight: 600, fontSize: '2.8rem', letterSpacing: '-.02em' }}>{elitePrice}</span>
              </div>
              <div style={{ fontSize: '0.72rem', color: 'var(--muted)', marginBottom: '16px' }}>{elitePeriod}</div>
              <ul style={{ listStyle: 'none', textAlign: 'left', width: '100%', display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '20px' }}>
                {['Tudo do Pro', 'Masterclasses ao vivo', 'Análise avançada', 'Suporte prioritário', 'Comunidade Elite'].map((feature) => (
                  <li key={feature} style={{ fontSize: '0.78rem', color: 'var(--muted)', display: 'flex', gap: '8px' }}>
                    <span style={{ color: 'var(--green)' }}>✓</span>{feature}
                  </li>
                ))}
              </ul>
              <a href={eliteHref} target="_blank" rel="noopener noreferrer" className="asn-btn-outline" style={{ width: '100%' }}>
                Assinar Elite
              </a>
            </div>
          </div>
        </section>

        {currentPlan !== 'free' && (
          <section className="asn-card" style={{ background: 'rgba(252,129,129,0.04)', border: '1px solid rgba(252,129,129,0.15)' }}>
            <div className="asn-section-eyebrow">Cancelar assinatura</div>
            <div className="asn-section-title">Gerenciar cancelamento</div>
            <div style={{ color: 'var(--white)', lineHeight: 1.8, marginBottom: '20px' }}>
              Para cancelar sua assinatura, acesse diretamente o painel da Kiwify com o e-mail usado na compra. O cancelamento é imediato e você mantém o acesso até o fim do período pago.
            </div>
            <a href="https://kiwify.com.br" target="_blank" rel="noopener noreferrer" className="asn-btn-danger" style={{ marginBottom: '14px' }}>
              Acessar painel da Kiwify para cancelar ↗
            </a>
            <div style={{ color: 'var(--muted)', fontSize: '0.84rem' }}>
              Dúvidas? Entre em contato: <a href="mailto:contato@pokermindbrasil.com" style={{ color: 'var(--white)' }}>contato@pokermindbrasil.com</a>
            </div>
          </section>
        )}

        <section className="asn-card">
          <div className="asn-section-eyebrow">FAQ de cobrança</div>
          <div className="asn-section-title">Dúvidas frequentes</div>
          {faqCobranca.map((item, index) => {
            const isOpen = openFaq === index;
            return (
              <div className="asn-faq-item" key={item.q}>
                <div className="asn-faq-q" onClick={() => setOpenFaq(isOpen ? null : index)}>
                  <span>{item.q}</span>
                  <span className={`asn-faq-arrow ${isOpen ? 'open' : ''}`}>⌄</span>
                </div>
                <div className={`asn-faq-a ${isOpen ? 'open' : ''}`}>{item.a}</div>
              </div>
            );
          })}
        </section>
      </main>

      <style>{`
        .asn-page {
          min-height: 100vh;
          background: #090909;
          color: #fff;
          font-family: 'Barlow', sans-serif;
        }

        .asn-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          padding: 18px 40px;
          border-bottom: 1px solid rgba(255,255,255,0.08);
          background: rgba(12,12,12,0.95);
          backdrop-filter: blur(20px);
          position: sticky;
          top: 0;
          z-index: 100;
        }

        .asn-back {
          font-size: 0.84rem;
          color: var(--muted);
          text-decoration: none;
          display: flex;
          align-items: center;
          gap: 6px;
          transition: color 0.15s;
        }

        .asn-back:hover {
          color: var(--white);
        }

        .asn-body {
          max-width: 860px;
          margin: 0 auto;
          padding: 48px 24px 80px;
          display: flex;
          flex-direction: column;
          gap: 32px;
        }

        .asn-section-eyebrow {
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 0.68rem;
          font-weight: 700;
          letter-spacing: .14em;
          text-transform: uppercase;
          color: var(--muted);
          margin-bottom: 4px;
        }

        .asn-section-title {
          font-family: 'Barlow Condensed', sans-serif;
          font-weight: 700;
          font-size: 1.25rem;
          letter-spacing: .04em;
          text-transform: uppercase;
          color: var(--white);
          margin-bottom: 16px;
        }

        .asn-card {
          background: rgba(255,255,255,0.03);
          border: 1px solid rgba(255,255,255,0.08);
          border-radius: 16px;
          padding: 28px;
        }

        .asn-plan-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 4px 12px;
          border-radius: 6px;
          font-family: 'Barlow Condensed', sans-serif;
          font-weight: 800;
          font-size: 0.78rem;
          letter-spacing: .1em;
          text-transform: uppercase;
          margin-bottom: 12px;
        }

        .asn-btn-primary {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 12px 28px;
          background: var(--yellow);
          color: #000;
          border: none;
          border-radius: 10px;
          font-family: 'Barlow Condensed', sans-serif;
          font-weight: 800;
          font-size: 0.92rem;
          letter-spacing: .06em;
          text-transform: uppercase;
          text-decoration: none;
          cursor: pointer;
          transition: opacity 0.2s;
        }

        .asn-btn-primary:hover {
          opacity: 0.88;
        }

        .asn-btn-outline {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 11px 24px;
          background: transparent;
          color: var(--white);
          border: 1px solid rgba(255,255,255,0.2);
          border-radius: 10px;
          font-family: 'Barlow Condensed', sans-serif;
          font-weight: 700;
          font-size: 0.88rem;
          letter-spacing: .06em;
          text-transform: uppercase;
          text-decoration: none;
          cursor: pointer;
          transition: background 0.15s;
        }

        .asn-btn-outline:hover {
          background: rgba(255,255,255,0.05);
        }

        .asn-btn-danger {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 11px 24px;
          background: transparent;
          color: var(--red);
          border: 1px solid rgba(252,129,129,0.3);
          border-radius: 10px;
          font-family: 'Barlow Condensed', sans-serif;
          font-weight: 700;
          font-size: 0.88rem;
          letter-spacing: .06em;
          text-transform: uppercase;
          text-decoration: none;
          cursor: pointer;
          transition: background 0.15s;
        }

        .asn-btn-danger:hover {
          background: rgba(252,129,129,0.06);
        }

        .asn-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 0.84rem;
        }

        .asn-table th {
          text-align: left;
          padding: 8px 12px;
          font-size: 0.68rem;
          font-weight: 700;
          letter-spacing: .1em;
          text-transform: uppercase;
          color: var(--muted);
          border-bottom: 1px solid rgba(255,255,255,0.08);
        }

        .asn-table td {
          padding: 12px;
          border-bottom: 1px solid rgba(255,255,255,0.05);
          color: var(--white);
        }

        .asn-empty {
          text-align: center;
          padding: 32px;
          color: var(--muted);
          font-size: 0.84rem;
          line-height: 1.7;
        }

        .asn-faq-item {
          border-bottom: 1px solid rgba(255,255,255,0.07);
        }

        .asn-faq-q {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 16px;
          padding: 16px 4px;
          cursor: pointer;
          font-size: 0.9rem;
          font-weight: 600;
          color: var(--white);
          transition: color 0.15s;
        }

        .asn-faq-q:hover {
          color: var(--yellow);
        }

        .asn-faq-arrow {
          transition: transform 0.2s;
          font-size: 1rem;
          color: var(--muted);
        }

        .asn-faq-arrow.open {
          transform: rotate(180deg);
        }

        .asn-faq-a {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease;
          font-size: 0.84rem;
          color: var(--muted);
          line-height: 1.7;
        }

        .asn-faq-a.open {
          max-height: 200px;
          padding-bottom: 16px;
        }

        .asn-currentPlan {
          position: absolute;
          top: -12px;
          left: 50%;
          transform: translateX(-50%);
          padding: 3px 12px;
          border-radius: 4px;
          font-family: 'Barlow', sans-serif;
          font-weight: 800;
          font-size: 0.65rem;
          letter-spacing: .06em;
          text-transform: uppercase;
          white-space: nowrap;
        }

        .asn-planGrid {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 16px;
        }

        @media (max-width: 760px) {
          .asn-planGrid {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 600px) {
          .asn-header {
            padding: 14px 16px;
          }

          .asn-body {
            padding: 28px 16px 60px;
          }

          .asn-card {
            padding: 20px 16px;
          }
        }
      `}</style>
    </div>
  );
}

export default Assinatura;
